'use strict';
// jshint ignore: start
angular.module('singleConceptAuthoringApp')
  .controller('inactivateComponentModalCtrl', function ($rootScope, $scope, $modalInstance, $filter, ngTableParams, terminologyServerService, componentType, reasons, associationTargets, conceptId, concept, description, branch, deletion, $routeParams, $q, metadataService, modalService) {

    // the selected tab
    $scope.actionTab = 1;

    $scope.tableLimit = 200;

    $scope.descendants = null;

    $scope.useFirstTarget = {selected: false};

    $scope.partiallyEquivalentToAssociationFound = false;

    $scope.possiblyReplacedByAssociationFound = false;   

    // required arguments
    $scope.componentType = componentType;
    $scope.deletion = deletion;
    $scope.reasons = reasons;

    // optional arguments (but if conceptId or branch specified, the other must
    // be as well)
    $scope.conceptId = conceptId;
    $scope.concept = concept;
    $scope.description = description;
    $scope.branch = branch;
    $scope.associationTargets = associationTargets;
    $scope.originalAssocs = associationTargets;

    $scope.inactivationReason = $scope.reasons ? $scope.reasons[0] : null;
    // construct the associations array and add a blank row
    $scope.associations = [];
    $scope.contextLanguageRefSetAssociations = [];

    $scope.unmodifiedAssociations = [];

    // display flags
    $scope.descendantsLoading = true;
    $scope.inboundRelationshipsLoading = true;

    $scope.filterByInactivationReason = function () {
      return function (item) {
        return $scope.inactivationReason && $scope.inactivationReason.display.indexOf(item.display) !== -1;
      };
    };

    $scope.updateAssociations = function (inactivationReason) {
      $scope.inactivationReason = inactivationReason;
      $scope.useFirstTarget = {selected: false};
      $scope.associationTargets = $scope.originalAssocs.filter($scope.filterByInactivationReason());

      if ($scope.associationTargets.length === 0) {
        $scope.associations = [];
      } else {

        // use the original historical association targets for the exsiting inactive concept
        if($scope.componentType === 'Concept' && !$scope.deletion && $scope.concept && $scope.unmodifiedAssociations.length !== 0) {
          $scope.associations = [];
          if ($scope.associationTargets.length !== 0 && $scope.associationTargets[0].id) {
              for (let i = 0; i < $scope.unmodifiedAssociations.length; i++) {
                $scope.associations.push({type: $scope.associationTargets[0], concept: $scope.unmodifiedAssociations[i].concept});
              }
          }

          if ($scope.componentType === 'Concept' && $scope.associations.length > 1 && ($scope.inactivationReason.id === 'DUPLICATE' || $scope.inactivationReason.id === 'ERRONEOUS' || $scope.associationTargets[0].id === '' || $scope.associationTargets[0].id === 'REPLACED_BY')) {
            $scope.associations = [$scope.associations[0]];
          }

          if ($scope.associations.length === 0) {
            $scope.addAssociation(0);
          }         
        } else {
          if ($scope.associations.length === 0) {
            $scope.addAssociation(0);
          }
  
          if ($scope.componentType === 'Concept' && $scope.associations.length > 1
              && ($scope.inactivationReason.id === 'DUPLICATE' || $scope.inactivationReason.id === 'ERRONEOUS' || $scope.associationTargets[0].id === '' || $scope.associationTargets[0].id === 'REPLACED_BY')) {
            $scope.associations = [$scope.associations[0]];
          }
  
          //Association type will be automatically populated if there is only one option
          for (let i = 0; i < $scope.associations.length; i++) {
            // extract association for convenience
            let association = $scope.associations[i];
            association.type = null;
            delete association.concept;
            if($scope.associationTargets.length !== 0) {
              association.type = $scope.associationTargets[0];              
            }
          }
        }        
      }
    };

    $scope.getConceptsForTypeahead = function (searchStr,inactivationIndication) {
      return terminologyServerService.findConceptsForQuery($routeParams.projectKey, $routeParams.taskKey, searchStr, 0, 20, null).then(function (response) {
        let i = 0;
        while (i < response.length) {
          let j = i + 1;
          while (j < response.length){
            if (response[j].concept.conceptId === response[i].concept.conceptId) {
              response.splice(j, 1);
            } else {
              j++;
            }
          }
          i++;
        }

        response = response.filter(function (el) {
          if (inactivationIndication) {
            return el.concept.active === true && $scope.conceptId !== el.concept.conceptId;
          } else {
            return el.concept.active === true;
          }
        });
        return response;
      });
    };

    function addCommas(integer) {
      return (integer + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }

    $scope.getTypeaheadConcepts = function(searchStr, inactivationIndication) {
      var patt = new RegExp('^\\d+\\s\\|.*\\|$');
      if (patt.test(searchStr)) {
        searchStr = searchStr.substring(0, searchStr.indexOf(' '));
      }
      return terminologyServerService.searchAllConcepts(metadataService.getBranch(), searchStr, null, 0, 50, null, true, true).then(function (response) {
        let descendants = [];

        if($scope.descendants) {
          angular.forEach($scope.descendants.items, function(descendant) {
            descendants.push(descendant.concept.conceptId);
          });
        }

        if (response.length === 1) {
            response.total = 1;
            response.items = [];
          if (inactivationIndication
            && $scope.conceptId !== response[0].concept.conceptId
            && !(descendants.includes(response[0].concept.conceptId))) {
            response.items.push(response[0]);
          }
        } else {
          response.items = response.items.filter(function (el) {
            if (inactivationIndication) {
              if(($scope.conceptId !== el.concept.conceptId) && !(descendants.includes(el.concept.conceptId)) && !isConceptExistingInAssociations(el.concept.conceptId)) {
                return ($scope.conceptId !== el.concept.conceptId) && !(descendants.includes(el.concept.conceptId)) && !isConceptExistingInAssociations(el.concept.conceptId);
              } else {
                response.total--;
              }
            }
          });
        }

        let dropdown = $('#inactivateComponentModal .dropdown-menu');

        dropdown.children('.dropdown-menu-total').remove();

        if((response.total - response.items.length) > 1) {
          let totalRow = $('<li>along with ' + addCommas(response.total - response.items.length) + ' other results</li>').addClass('dropdown-menu-total');
          dropdown.append(totalRow);
        }

        return response.items;
      });
    };

    $scope.selectHistoricalAssocTarget = function() {
      $scope.unmodifiedAssociations = angular.copy($scope.associations);
    };

    function isConceptExistingInAssociations (conceptId) {
      if ($scope.associations && $scope.associations.length !== 0) {
        for (var i = 0; i < $scope.associations.length; i++) {
          if ($scope.associations[i].concept
              && $scope.associations[i].concept.concept.conceptId === conceptId) {
            return true;
          }
        }
      }
      return false;
    }

// declare table parameters
    $scope.tableParamsChildren = new ngTableParams({
        page: 1,
        count: 10,
        sorting: {
          characteristicType: 'desc',
          sourceFsn: 'asc'
        },
        orderBy: 'sourceFsn'
      },
      {
        total: $scope.children ? $scope.children.length : 0, // length of data
        getData: function ($defer, params) {

          if (!$scope.children || $scope.children.length === 0) {
            $defer.resolve([]);
          } else {

            params.total($scope.children.length);
            let childrenDisplayed = params.sorting() ? $filter('orderBy')($scope.children, params.orderBy()) : $scope.children;

            $defer.resolve(childrenDisplayed.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          }

        }
      }
    );

// declare table parameters
    $scope.tableParamsDescendants = new ngTableParams({
        page: 1,
        count: 10,
        sorting: {
          sortableName: 'asc'
        },
        orderBy: 'sortableName'
      },
      {
        total: $scope.descendants && $scope.descendants.items ? $scope.descendants.items.length : 0, // length
        // of
        // data
        getData: function ($defer, params) {

          if (!$scope.descendants || !$scope.descendants.items) {
            $defer.resolve([]);
          } else {
            params.total($scope.descendants.items.length);
            let descendantsDisplayed = params.sorting() ? $filter('orderBy')($scope.descendants.items, params.orderBy()) : $scope.descendants.items;

            $defer.resolve(descendantsDisplayed.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          }

        }
      }
    );

// declare table parameters
    $scope.tableParamsInboundRelationships = new ngTableParams({
        page: 1,
        count: 10,
        sorting: {
          characteristicType: 'desc',
          sourceFsn: 'asc'
        },
        orderBy: 'sourceFsn'
      },
      {
        total: $scope.inboundRelationships ? $scope.inboundRelationships.length : 0, // length of
        // data
        getData: function ($defer, params) {

          if (!$scope.inboundRelationships || $scope.inboundRelationships.length === 0) {
            $defer.resolve([]);
          } else {

            params.total($scope.inboundRelationships.length);
            let inboundRelationshipsDisplayed = params.sorting() ? $filter('orderBy')($scope.inboundRelationships, params.orderBy()) : $scope.inboundRelationships;
            $defer.resolve(inboundRelationshipsDisplayed.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          }
        }
      }
    );

    $scope.tableParamsReferenceSetAssociations = new ngTableParams({
        page: 1,
        count: 10,
        sorting: {
          characteristicType: 'desc',
          sourceFsn: 'asc'
        },
        orderBy: 'sourceFsn'
      },
      {
        total: $scope.referenceSetAssociations ? $scope.referenceSetAssociations.length : 0,
        getData: function ($defer, params) {

          if (!$scope.referenceSetAssociations || $scope.referenceSetAssociations.length === 0) {
            $defer.resolve([]);
          } else {

            params.total($scope.referenceSetAssociations.length);
            let referenceSetsDisplayed = params.sorting() ? $filter('orderBy')($scope.referenceSetAssociations, params.orderBy()) : $scope.referenceSetAssociations;
            $defer.resolve(referenceSetsDisplayed.slice((params.page() - 1) * params.count(), params.page() * params.count()));
          }
        }
      }
    );

    $scope.hasNoConceptTarget = function () {
        for (let i = 0; i < $scope.associations.length; i++) {
          let association = $scope.associations[i];
          if(!association.concept || !association.concept.concept || !association.concept.concept.conceptId
            || !association.type || !association.type.id) {
            return true;
          }
       }
       return false;
    };

    $scope.hasHistAssocType = function () {
      for (let i = 0; i < $scope.associations.length; i++) {
        var association = $scope.associations[i];
        if (association.type && association.type.id) {
          return true;
        }
      }
      return false;
    };

    $scope.checkAssociationPartiallyEquivalentTo = function () {
      let count = 0;
      $scope.partiallyEquivalentToAssociationFound = false;
      for (let i = 0; i < $scope.associations.length; i++) {
        let association = $scope.associations[i];
        if(association.type && association.type.id == 'PARTIALLY_EQUIVALENT_TO') {
          $scope.partiallyEquivalentToAssociationFound = true;
          count++;
        }
      }
      return $scope.partiallyEquivalentToAssociationFound ? count < 2 : false;
    };

    $scope.checkAssociationPossiblyReplacedBy = function () {
      let count = 0;
      $scope.possiblyReplacedByAssociationFound = false;
      for (let i = 0; i < $scope.associations.length; i++) {
        let association = $scope.associations[i];
        if(association.type && association.type.id == 'POSSIBLY_REPLACED_BY') {
          $scope.possiblyReplacedByAssociationFound = true;
          count++;
        }
      }
      return $scope.possiblyReplacedByAssociationFound ? count < 2 : false;
    };

    $scope.selectReason = function () {

      // NOTE: associationTarget is optional
      if (!$scope.inactivationReason && !$scope.deletion) {
        window.alert('You must specify a reason for inactivation');
      } else {
        if ($scope.inactivationReason && $scope.inactivationReason.id === 'AMBIGUOUS'
            && $scope.associations.filter(function(item) { return item.type.id === 'POSSIBLY_EQUIVALENT_TO' }).length < 2) {
              modalService.confirm('Only one POSSIBLY EQUIVALENT TO association reference set provided for Ambiguous inactivation reason. Do you want to proceed?').then(function () {
                proceedInactivation();
              });
        } else {
          proceedInactivation();
        }
      }
    };

    function proceedInactivation() {
      let associationTarget = {};

      // FORMAT: associationTargets: {MOVED_FROM: ["139569002"]}
      // validate and convert association targets
      for (let i = 0; i < $scope.associations.length; i++) {
        // extract association for convenience
        let association = $scope.associations[i];


        // if neither type nor concept specified
        if (!association.concept || !$scope.deletion && !association.type) {
          // Probably need to re-write this if-else statement as it is unused
        }

        // if either field is blank, alert and return
//          else if (!association.type || !association.concept) {
//            window.alert('You must specify both the association type and target');
//            return;
//          }

        // add the association type/target
        else {

          if(!association.type || association.type === null){
              association.type = {id: ' '}
          }

          // if this type already specified, add to array
          if (associationTarget.hasOwnProperty(association.type.id)) {
            associationTarget[association.type.id].push(association.concept.concept.conceptId);
          }

          // otherwise, set this type to a single-element array containing
          // this concept
          else if(association.type.id){
            associationTarget[association.type.id] = [association.concept.concept.conceptId];
          }
        }
      }

      let results = {};
      results.reason = $scope.inactivationReason;
      results.associationTarget = associationTarget;
      results.useFirstTarget = $scope.componentType === 'Concept' ? $scope.useFirstTarget.selected : false;
      if($scope.deletion)
      {
          results.deletion = true;
      }

      $modalInstance.close(results);
    }

    $scope.selectDeletion = function (reason) {

      // NOTE: associationTarget is optional
      if (reason.concept) {
        window.alert('You must specify a replacement concept');
      } else {
        let results = {};
        results.deletion = true;
        results.concept = reason.concept;

        $modalInstance.close(results);
      }
    };

    $scope.delete = function () {

        let results = {};
        results.deletion = true;
        $modalInstance.close(results);
    };

    /**
     * Helper function to get and set a page of, or all, inbound relationships
     * @param conceptId
     * @param branch
     * @param startIndex
     * @param maxResults
     */
    function getInboundRelationships(conceptId) {
      let deferred = $q.defer();
      $scope.inboundRelationshipsLoading = true;
      // get the concept relationships again (all)
      terminologyServerService.searchConcepts($scope.branch,'', '*: *' + ' = ' + conceptId, 0, 10000, false, false, true).then(function (response) {

        // initialize the arrays
        $scope.inboundRelationships = [];
        $scope.children = [];
        $scope.inboundRelationshipsTotal = 0;

        // ng-table cannot handle e.g. source.fsn sorting, so extract fsns and
        // make top-level properties
        angular.forEach(response.items, function (item) {
          if (item.active) {
            item.sourceFsn = item.fsn.term;
            item.typeFsn = 'isA (attribute)';
            item.source = [];
            item.source.fsn = item.fsn.term;
            item.concept = [];
            item.concept.conceptId = item.conceptId;
            item.characteristicType = 'STATED_RELATIONSHIP';

            // push to inbound relationships
            $scope.inboundRelationships.push(item);
            $scope.inboundRelationshipsTotal++;
          }
        });
        $rootScope.children = $scope.children;
        $scope.tableParamsChildren.reload();
        $scope.tableParamsInboundRelationships.reload();

        // Children
        terminologyServerService.searchConcepts($scope.branch,'', '<! ' + conceptId, 0, 10000, false, false, true).then(function (response) {
            // ng-table cannot handle e.g. source.fsn sorting, so extract fsns and
            // make top-level properties
            angular.forEach(response.items, function (item) {

              if (item.active) {
                item.sourceFsn = item.fsn.term;
                item.source = [];
                item.source.fsn = item.fsn.term;
                item.typeFsn = 'isA (attribute)';
                item.concept = [];
                item.concept.conceptId = item.conceptId;
                item.characteristicType = 'STATED_RELATIONSHIP';

                var found = $scope.inboundRelationships.filter(function(inboundRelationship) {
                  return item.sourceFsn === inboundRelationship.sourceFsn;
                }).length !== 0;

                // push to inbound relationships
                if (!found)
                {
                  $scope.inboundRelationships.push(item);
                  $scope.inboundRelationshipsTotal++;
                }

                $scope.children.push(item);
              }
            });
            $rootScope.children = $scope.children;
            $scope.tableParamsChildren.reload();

            if ($scope.deletion) {
              // Historical associations
              getHistoricalAssociations().then(function(affectedAssociations) {
                $scope.inboundRelationships = $scope.inboundRelationships.concat(affectedAssociations);
                $scope.inboundRelationshipsTotal += affectedAssociations.length;
                $scope.inboundRelationshipsLoading = false;
                $scope.tableParamsInboundRelationships.reload();
              })
            }
            else {
              $scope.inboundRelationshipsLoading = false;
              $scope.tableParamsInboundRelationships.reload();
            }

            deferred.resolve();
          });
      });

      return deferred.promise;
    }

    function getReferenceSetAssociations() {
      const excludedRefset = ['733073007', '900000000000497000'];
      terminologyServerService.getReferenceSetsByReferencedComponent($scope.conceptId, $scope.branch).then(function (response) {
          if (response !== null) {
            $scope.referenceSetAssociations = [];
            angular.forEach(response.items, function (item) {
              if (!excludedRefset.includes(item.refsetId)) {
                let newItem = angular.copy(item);
                newItem.refsetPt = response.referenceSets[item.refsetId].pt.term;
                $scope.referenceSetAssociations.push(newItem);
              }
            });
            $scope.tableParamsReferenceSetAssociations.reload();
          }
      });
    }

    function getHistoricalAssociations() {
      let deferred = $q.defer();
      var affectedAssociations = [];
      terminologyServerService.getHistoricalAssociationMembers($scope.conceptId, $scope.branch).then(function (response) {
        let affectedAssociationsTotal = Array.isArray(response) ? response.length : response.total;
        var affectedDescriptionIds = [];
        if (affectedAssociationsTotal !== 0) {
          angular.forEach(response.items, function (item) {
            if (item.active) {
              // Historical concepts found
              if (item.referencedComponent) {
                item.sourceFsn = item.referencedComponent.term;
                item.source = [];
                item.source.fsn = item.referencedComponent.term;
                item.characteristicType = 'STATED_RELATIONSHIP';

                var found = $scope.inboundRelationships.filter(function(inboundRelationship) {
                  return item.sourceFsn === inboundRelationship.sourceFsn;
                }).length !== 0;

                // push to inbound relationships
                if (!found)
                {
                  affectedAssociations.push(item);
                }
              }
              else {
                affectedDescriptionIds.push(item.referencedComponentId);
              }
            }
          });
        }

        // Historical associations found
        if (affectedDescriptionIds.length > 0) {
          var count = 0;
          for (var i = 0; i < affectedDescriptionIds.length; i++) {
            terminologyServerService.getDescriptionProperties(affectedDescriptionIds[i], $scope.branch).then(function (description) {
              var conceptIds = [];
              conceptIds.push(description.conceptId);
              count++;
              if (count === affectedDescriptionIds.length) {
                // bulk call for concept ids
                terminologyServerService.bulkGetConceptUsingPOST(conceptIds, $scope.branch).then(function (response) {
                  angular.forEach(response.items, function (concept) {
                    var item = {};
                    item.sourceFsn = concept.fsn.term;
                    item.source = [];
                    item.source.fsn = concept.fsn.term;
                    item.characteristicType = 'STATED_RELATIONSHIP';

                    var found = $scope.inboundRelationships.filter(function(inboundRelationship) {
                        return item.sourceFsn === inboundRelationship.sourceFsn;
                      }).length !== 0
                      && $scope.affectedAssociations.filter(function(inboundRelationship) {
                        return item.sourceFsn === inboundRelationship.sourceFsn;
                      }).length !== 0;

                    // push to inbound relationships
                    if (!found)
                    {
                      affectedAssociations.push(item);
                    }
                  });

                  deferred.resolve(affectedAssociations);
                });
              }
            });
          }
        }
        else {
          deferred.resolve(affectedAssociations);
        }
      });

      return deferred.promise;
    }    

    $scope.cancel = function () {
      $modalInstance.dismiss();
    };

    $scope.switchHistoricalAssociationType = function(type){
      if ($scope.associations.length != 0) {
        if ($scope.isReplacedByHistoricalAssocPresent() || $scope.isSameAsHistoricalAssocPresent() || $scope.isNoRequiredHistoricalAssocPresent()) {
          if ($scope.isNoRequiredHistoricalAssocPresent()) {
            $scope.associations[0].concept = null;
          }
          $scope.associations = [$scope.associations[0]];
        }
        for (let i = 0; i < $scope.associations.length; i++) {
          $scope.associations[i].type = type;
        }
        if (!$scope.isNoRequiredHistoricalAssocPresent() && $scope.unmodifiedAssociations.length !== 0) {
          if ($scope.isReplacedByHistoricalAssocPresent() || $scope.isSameAsHistoricalAssocPresent()) {
            $scope.associations[0].concept = $scope.unmodifiedAssociations[0].concept;
          } else {
            $scope.associations = [];
            for (let i = 0; i < $scope.unmodifiedAssociations.length; i++) {
              $scope.associations.push({type: type, concept: $scope.unmodifiedAssociations[i].concept});
            }
          }         
        }
      }
    };

    $scope.addAssociation = function (index) {
      if(typeof index !== 'undefined' && $scope.inactivationReason) {
        if ($scope.associationTargets.length !== 0) {
          $scope.associations.push({type: $scope.associationTargets[0], concept: null});
        }
      } else {
        let type = null;
        if ($scope.associations.length != 0) {
          for (let i = 0; i < $scope.associations.length; i++) {
            if ($scope.associations[i].type) {
              type = $scope.associations[i].type;
              break;
            }
          }
        }
        let newHistoricalAssoc = {type: type, concept: null};

        // re-popuate historical assoc target
        if ($scope.unmodifiedAssociations.length !== 0) {
          for (let i = 0; i < $scope.unmodifiedAssociations.length; i++) {
            let found = false;
            for (let j = 0; j < $scope.associations.length; j++) {
              if ($scope.unmodifiedAssociations[i].concept.concept.conceptId === $scope.associations[j].concept.concept.conceptId) {
                found = true;
                break;
              }
            }
            if (!found) {
              newHistoricalAssoc.concept = $scope.unmodifiedAssociations[i].concept;
              break
            }
          }
        }
        
        $scope.associations.push(newHistoricalAssoc);
      }
    };

    $scope.removeAssociation = function (index) {
      $scope.associations.splice(index, 1);
      if ($scope.associations.length === 0) {
        $scope.unmodifiedAssociations = [];
        $scope.addAssociation(0);
      } else {
        $scope.unmodifiedAssociations = angular.copy($scope.associations);
      }      
    };

    $scope.isReplacedByHistoricalAssocPresent = function () {
      if ($scope.associations.length != 0) {
        for (let i = 0; i < $scope.associations.length; i++) {
          if ($scope.associations[i].type && ($scope.associations[i].type.id === 'REPLACED_BY')) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.isSameAsHistoricalAssocPresent = function () {
      if ($scope.associations.length != 0) {
        for (let i = 0; i < $scope.associations.length; i++) {
          if ($scope.associations[i].type && ($scope.associations[i].type.id === 'SAME_AS')) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.isNoRequiredHistoricalAssocPresent = function () {
      if ($scope.associations.length != 0) {
        for (let i = 0; i < $scope.associations.length; i++) {
          if ($scope.associations[i].type && $scope.associations[i].type.id === '') {
            return true;
          }
        }
      }

      return false;
    };

    $scope.getcontextLanguageRefSetAssociationsText = function() {
      return $scope.contextLanguageRefSetAssociations.map(function(elem) { return elem.refsetId + ' |' + (elem.fsn ? elem.fsn : elem.label) + '|'; }).join(',');
    }

    function initializeHistoricalAssocs() {
      $scope.associations = [];
      var allCocnceptTargets = [];
      for (const property in $scope.concept.associationTargets) {
        allCocnceptTargets = allCocnceptTargets.concat($scope.concept.associationTargets[property]);
      }
      terminologyServerService.searchAllConcepts(metadataService.getBranch(), allCocnceptTargets.join(','), null, 0, 50, null, true, true).then(function(response) {
        var conceptIdToConceptMap = response.items.reduce(function(map, obj) {
            map[obj.concept.conceptId] = obj;
            return map;
        }, {});
        for (const property in $scope.concept.associationTargets) {
          let foundAssociationTargets = $scope.associationTargets.filter(function(item) {return item.id === property});
          if (foundAssociationTargets.length !== 0) {
            for (let i = 0; i < $scope.concept.associationTargets[property].length; i++) {
              if (conceptIdToConceptMap[$scope.concept.associationTargets[property][i]]) {
                $scope.associations.push({type: foundAssociationTargets[0], concept:  conceptIdToConceptMap[$scope.concept.associationTargets[property][i]]});
              }
            }
            $scope.unmodifiedAssociations = angular.copy($scope.associations);
          }
        }
        if ($scope.associations.length === 0) {
          $scope.addAssociation();
        }
      });
    }

    ////////////////////////////////////
    // Initialization
    ////////////////////////////////////
    function initialize() {
      // check requirements
      if ($scope.conceptId && !$scope.branch) {
        $scope.error = 'Branch was not specified';
      }
      if ($scope.branch && !$scope.conceptId) {
        $scope.error = 'Concept id was not specified';
      }
      if (!$scope.reasons) {
        $scope.error = 'List of inactivation reasons was not specified';
      }

      // get the limited number of inbound relationships for display
      if ($scope.componentType === 'Concept') {
        $scope.reasons.sort(function(a, b) {
          let textA = a.text;
          let textB = b.text;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        getInboundRelationships($scope.conceptId);

        getReferenceSetAssociations();
      }

      // on load, retrieve children and descendants if concept specified
      if ($scope.conceptId && $scope.branch) {

        // limit the number of descendants retrieved to prevent overload
        terminologyServerService.searchAllConcepts($scope.branch, '', '<' + $scope.conceptId, 0, 50, null, true, true, null, null, 'stated').then(function (response) {
          $scope.descendants = response;
          $rootScope.descendants = response;
          $scope.descendantsLoading = false;
          $scope.tableParamsDescendants.reload();

          // convert the term into a top-level attribute for ng-table sorting
          angular.forEach($scope.descendants.items, function (descendant) {
            descendant.sortableName = descendant.concept.fsn;
          });
        });
      }

      // Edit inactive concept
      if($scope.componentType === 'Concept' && !$scope.deletion && $scope.concept && !$scope.concept.active) {
        let foundReasons = $scope.reasons.filter(function(reason) {return reason.id === $scope.concept.inactivationIndicator});
        if (foundReasons.length !== 0) {
          $scope.inactivationReason = foundReasons[0];
          $scope.associationTargets = $scope.originalAssocs.filter($scope.filterByInactivationReason());
          if ($scope.concept.associationTargets) {
            initializeHistoricalAssocs();
          } else {
            $scope.addAssociation();
          }
        } else {
          $scope.addAssociation();
          $scope.updateAssociations($scope.inactivationReason);
        }
      } else {
        $scope.addAssociation();
        $scope.updateAssociations($scope.inactivationReason);
      }

      if ($scope.componentType === 'Description' && $scope.description && $scope.description.active) {
        $scope.checkingContextLanguageRefSetAssociations = true;
        $scope.contextLanguageRefSetAssociations = [];
        let optionalLanguageRefsets = metadataService.getOptionalLanguageRefsets();
        if (optionalLanguageRefsets && optionalLanguageRefsets.length !== 0) {
          $scope.contextLanguageRefSetAssociations = optionalLanguageRefsets.filter(function(item) {return Object.keys($scope.description.acceptabilityMap).includes(item.refsetId)});
          if ($scope.contextLanguageRefSetAssociations.length !== 0) {
            const allRefsetIdStr = $scope.contextLanguageRefSetAssociations.map(function(elem) { return elem.refsetId;}).join(',');
            // Get FSNs for context based language refset
            terminologyServerService.searchAllConcepts($scope.branch, allRefsetIdStr, null, 0, 50, null, true, true).then(function (response) {
              if(response.items.length !== 0) {
                for (let i = 0; i < response.items.length; i++) {
                  for (let j = 0; j < $scope.contextLanguageRefSetAssociations.length; j++) {
                    if (response.items[i].concept.conceptId === $scope.contextLanguageRefSetAssociations[j].refsetId) {
                      $scope.contextLanguageRefSetAssociations[j]['fsn'] = response.items[i].concept.fsn;
                    }
                  }
                }
              }
              $scope.checkingContextLanguageRefSetAssociations = false;
            });
          } else {
            $scope.checkingContextLanguageRefSetAssociations = false;
          }
        } else {
          $scope.checkingContextLanguageRefSetAssociations = false;
        }
      }
    }

    initialize();
  })
;
